import React, { useCallback } from "react";
import { useAppDispatch } from "../../redux/configureStore";
import Modal from "./Modal";
import { WOLConfirmation } from "../../app/types";
import { confirmationResult } from "../app/uiSlice";

interface Props {
  confirmation: WOLConfirmation;
}

const Confirmation = ({ confirmation }: Props) => {
  const { title, msg, acceptText, denyText } = confirmation;
  const dispatch = useAppDispatch();
  const onAccept = useCallback(() => {
    dispatch(confirmationResult(confirmation.uuid, true));
  }, [confirmation.uuid, dispatch]);

  const onDecline = useCallback(() => {
    dispatch(confirmationResult(confirmation.uuid, false));
  }, [confirmation.uuid, dispatch]);

  return (
    <Modal
      title={title}
      msg={msg}
      showCancel
      onAccept={onAccept}
      onCancel={onDecline}
      acceptText={acceptText}
      denyText={denyText}
    />
  );
};

export default Confirmation;
